import { Component } from '@angular/core';
import { AuthenticationService } from '../../_shared/authentication.service';
import { BaseComponent } from '../../_shared/base.component';
import { Router } from '@angular/router';
import { MessageService } from '../../layout/message/message.service';

export class User {
	Username: string;
	Password: string;
	RedirectUrl: string;
	constructor() {
		this.Username = '';
		this.Password = '';
		this.RedirectUrl = '/products';
	}
}

@Component({
	selector: 'pm-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css', '../../app.component.css'],
})
export class LoginComponent extends BaseComponent {
	user: User = new User();
	error = '';
	constructor(
		private authenticationService: AuthenticationService,
		router: Router,
		message: MessageService,
	) {
		super(router, message);
	}

	onSubmit() {
		this.messageService.clearSticky();
		this.authenticationService.login(this.user).subscribe(
			(response: any) => {
				const { Token, error } = response;
				const { Email, Role, Username } = response.User;
				// login successful if there's a jwt token in the response
				if (Token) {
					this.showInfoMessage(null, 'Logging in ...');
					// store username and jwt token in local storage to keep user logged in between page refreshes
					this.authenticationService
						.saveToken(
							{
								username: Username,
								token: Token,
								role: Role,
								email: Email,
							},
							Token,
						)
						.then(() => {
							setTimeout(() => {
								this.showSuccessMessage(null, 'Success');
								this._router.navigate([this.user.RedirectUrl]);
							}, 1000);
						});
				} else {
						this.showErrorMessage('Login', error.error);
				}
			},
			err => {
				this.showErrorMessage('Login', err.error);
			},
		);
	}
}
